import theme from '@clad-ui/theme';
import { styled } from '@linaria/react';
const {
  sizes,
  colors,
  radii
} = theme;
/**
 * NOTE:
 * - font-size to control icon's size
 * - color to control icon's color
 * - StyledComponent has an `as` prop which allows changing the HTML element later so span here is just for generic inline component
 */
const _exp = /*#__PURE__*/() => ({
  radius
}) => radii[radius];
const _exp2 = /*#__PURE__*/() => ({
  color = 'text'
}) => colors[color];
const _exp3 = /*#__PURE__*/() => ({
  bg
}) => bg.toLowerCase() === 'none' ? 'transparent' : colors[bg];
const _exp4 = /*#__PURE__*/() => ({
  size
}) => parseInt(sizes[size], 10) * (60 / 100);
const _exp6 = /*#__PURE__*/() => ({
  size
}) => sizes[size];
export const StyledComponent = /*#__PURE__*/styled('span')({
  name: "StyledComponent",
  class: "s1u6tmpv",
  propsAsIs: false,
  vars: {
    "s1u6tmpv-0": [_exp()],
    "s1u6tmpv-1": [_exp2()],
    "s1u6tmpv-2": [_exp3()],
    "s1u6tmpv-3": [_exp4(), "px"],
    "s1u6tmpv-4": [_exp6()]
  }
});

require("./ShapeIcon.styles.linaria.module.css");